import React from "react";
import { Button, Flex, Box } from "rebass";
import { getLocalizedString } from "../../utils";
import Alert from "../../icons/Alert";
import useResponsive from "../../hooks/useResponsive";

const ToastMessage = ({
  message = null,
  needConfirm = false,
  confirmFunction = null,
  cancelFunction = null,
  buttonLabelCode = "OK",
  style,
}) => {
  const { isMobile } = useResponsive();

  return (
    <Box
      style={{
        backgroundColor: "rgba(0,0,0,.85)",
        zIndex: 999999,
        display: message ? "flex" : "none",
      }}
      className="modal"
      // w={["60vw", null, null]}
    >
      {!isMobile ? (
        <div className="modal-content" style={style}>
          <Flex
            flexDirection={"column"}
            style={{ color: "black", marginTop: -50 }}
            alignItems={"center"}
            pt={5}
          >
            <Alert style={{ marginBottom: 25 }} />
            {message?.includes?.("\n") && (
              <Flex
                flexDirection={"column"}
                style={{
                  color: "black",
                  maxHeight: "250px",
                  overflowY: "auto",
                }}
              >
                {message.split("\n").map((m, i) => (
                  <Box mb={1} key={i}>
                    <strong>{m}</strong>
                  </Box>
                ))}
              </Flex>
            )}
          </Flex>
          <Flex
            flexDirection={"column"}
            style={{ color: "black", marginTop: -60 }}
            alignItems={"center"}
            pt={5}
          >
            <Box
              style={{
                maxWidth: "450px",
                alignItems: "center",
                textAlign: "center",
              }}
              alignItems={"center"}
            >
              {message && !message.includes?.("\n") && message}
            </Box>
          </Flex>
          <div className="relative right-0 top-0 pt-6 hidden md:block md:w-full">
            <span
              className="px-4 py-3 flex"
              style={{
                alignItems: "center",
                justifyContent: "center",
                gap: "10px",
              }}
            >
              <Button
                onClick={confirmFunction}
                sx={{
                  border: "1px solid #333",
                  backgroundColor: "#333",
                  minWidth: "150px",
                  marginLeft: "10px",
                  "&:hover": {
                    backgroundColor: "#909090",
                    border: "1px solid #909090",
                  },
                }}
              >
                {getLocalizedString(buttonLabelCode)}
              </Button>
              {needConfirm && (
                <Button
                  onClick={cancelFunction}
                  sx={{
                    border: "1px solid #333",
                    backgroundColor: "white",
                    width: "150px",
                    color: "black",
                    marginRight: "10px",
                    //transition: "300ms",
                    "&:hover": {
                      backgroundColor: "#909090",
                      border: "1px solid #909090",
                      color: "white",
                    },
                  }}
                >
                  {getLocalizedString("Annulla")}
                </Button>
              )}
            </span>
          </div>
          <div className="relative top-0 pt-10 md:hidden block md:w-full">
            <Button
              width={["50%", null, "100%"]}
              onClick={() => {
                //save(selectedDoors.filter(s => s.checked))
                //closeDoors();
              }}
              style={{
                border: "1px solid white",
                backgroundColor: "#333",
                marginRight: "10px",
              }}
            >
              {getLocalizedString("Ok")}
            </Button>
          </div>
        </div>
      ) : (
        <Flex
          bg="white"
          style={{ position: "fixed", left: "calc(50% - 40%)" }}
          width="80vw"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          p="10px"
        >
          <Alert style={{ marginBottom: 20, marginTop: "20px" }} />
          {message?.includes?.("\n") && (
            <Flex
              flexDirection={"column"}
              style={{
                color: "black",
                maxHeight: "250px",
                overflowY: "auto",
                marginBottom: "20px",
              }}
            >
              {message.split("\n").map((m, i) => (
                <Box mb={1} key={i}>
                  <strong>{m}</strong>
                </Box>
              ))}
            </Flex>
          )}
          {message && !message.includes?.("\n") && (
            <span style={{ marginBottom: "20px", textAlign: "center" }}>
              {message}
            </span>
          )}
          <Flex
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
            style={{ gap: "10px" }}
          >
            <Button
              onClick={confirmFunction}
              sx={{
                border: "1px solid #333",
                backgroundColor: "#333",
                width: "150px",
                // marginLeft: "10px",
                "&:hover": {
                  backgroundColor: "#909090",
                  border: "1px solid #909090",
                },
              }}
            >
              {getLocalizedString("OK")}
            </Button>
            {needConfirm && (
              <Button
                onClick={cancelFunction}
                sx={{
                  border: "1px solid #333",
                  backgroundColor: "white",
                  width: "150px",
                  color: "black",
                  // marginRight: "10px",
                  //transition: "300ms",
                  "&:hover": {
                    backgroundColor: "#909090",
                    border: "1px solid #909090",
                    color: "white",
                  },
                }}
              >
                {getLocalizedString("Annulla")}
              </Button>
            )}
          </Flex>
        </Flex>
      )}
    </Box>
  );
};

export { ToastMessage };
